import type { BaseModelAttributes } from './base';
import { TaskStatus } from './taskStatus';
import { I18nLabels } from './common';
import { Locale } from './locale';

export type MusicEditingStatus = TaskStatus;
export { TaskStatus as MusicEditingStatusEnum };

/** 移除 extract/complete，新增 song_cover/separate */
export type MusicEditingType = 'cover' | 'repaint' | 'song_cover' | 'separate';
export type MusicType = 'generation' | 'editing';

export const MusicEditingTypeLabels: I18nLabels<MusicEditingType> = {
  cover: { [Locale.ZH_CN]: '风格变体', [Locale.EN_US]: 'Style Variant' },
  repaint: { [Locale.ZH_CN]: '片段重绘', [Locale.EN_US]: 'Repaint' },
  song_cover: { [Locale.ZH_CN]: '歌曲翻唱', [Locale.EN_US]: 'Song Cover' },
  separate: { [Locale.ZH_CN]: '人声/伴奏分离', [Locale.EN_US]: 'Vocal/Instrumental Split' },
};

export interface IMusicEditing extends BaseModelAttributes {
  title?: string;              // 用户自定义标题（可选）
  musicType: MusicType;
  editingType: MusicEditingType;
  srcAudioUrl: string;
  modelId: string;
  status: MusicEditingStatus;
  taskId?: string;
  resultAudioUrl?: string;
  resultMessage?: string;
  userId: string;
  submittedAt?: Date;
  completedAt?: Date;
  // cover 专用
  referenceAudioUrl?: string;
  audioCoverStrength?: number;
  coverNoiseStrength?: number;
  // repaint 专用
  repaintingStart?: number;
  repaintingEnd?: number;
  // song_cover 专用
  rvcModelId?: string;
  pitch?: number;
  indexRate?: number;
  // separate 专用
  secondaryResultAudioUrl?: string;
  // 可选描述
  prompt?: string;
}

export interface CreateMusicEditingRequest {
  editingType: MusicEditingType;
  srcAudioUrl: string;
  modelId: string;
  prompt?: string;
  // cover
  referenceAudioUrl?: string;
  audioCoverStrength?: number;
  coverNoiseStrength?: number;
  // repaint
  repaintingStart?: number;
  repaintingEnd?: number;
  // song_cover
  rvcModelId?: string;
  pitch?: number;
  indexRate?: number;
  vocalGainDb?: number;
  instrumentalGainDb?: number;
  cleanAudio?: boolean;
  f0Autotune?: boolean;
  // separate
  uvrModel?: string;
  enableBackingVocalRemoval?: boolean;
  // song_cover / separate 共用
  outputFormat?: string;
}

export interface CreateSongCoverRequest {
  srcAudioUrl: string;
  modelId: string;
  rvcModelId: string;
  pitch?: number;
  indexRate?: number;
}

export interface CreateSeparateRequest {
  srcAudioUrl: string;
  modelId: string;
  uvrModel?: string;
  enableBackingVocalRemoval?: boolean;
  outputFormat?: string;
}

export interface MusicEditingQuery {
  search?: string;
  status?: MusicEditingStatus;
  editingType?: MusicEditingType;
  modelId?: string;
}
